import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mr-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn bg-transparent border-success text-success rounded-pill border-2 btn-icon"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash" })
], -1)
const _hoisted_3 = { class: "media-body" }
const _hoisted_4 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_5 = { class: "font-italic mr-3" }
const _hoisted_6 = { class: "font-italic" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      href: "#",
      class: "media align-items-center",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToObject && _ctx.goToObject(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, "#" + _toDisplayString(_ctx.data.pid), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.project_name) + " ", 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.data.p_vorname) + " " + _toDisplayString(_ctx.data.p_name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.data.p_email), 1),
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.data.p_tel), 1)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.data.p_strasse) + " " + _toDisplayString(_ctx.data.p_hnr) + " | " + _toDisplayString(_ctx.data.p_plz) + " " + _toDisplayString(_ctx.data.p_ort), 1)
      ]),
      _hoisted_8
    ])
  ]))
}